import React, { useState } from "react";
import { Card, Col, Row, Spin } from "antd";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getStoreByIdAsync,
  updateStoreStatusAsync,
} from "../../services/StoreManagementServices";
import { asyncStatus } from "../../utils/asyncStatus";
import StorePreview from "../Store/StorePreview"; 
import { useEffect } from "react";
import { apiHandle } from "../../config/apiHandle";

const StoreDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation()
  const [vendorDetails, setVendorDetails] = useState(null);
  
  const { user } = useSelector((state) => state.userAuth);
  
  
  const {
    get_store_by_id_data,
    get_store_by_id_status,
    update_store_status_status,
  } = useSelector((state) => state.storeManagement);

  const storeLoader = get_store_by_id_status === asyncStatus.LOADING;
  const updateStoreStatusLoader = update_store_status_status === asyncStatus.LOADING;


  const fetchVendorDetail = async ( ) =>{
    const adminRoute = `get-my-store/${get_store_by_id_data?.store?.vendor_id}`
    const vendorRoute = `get-my-store/${user._id}`;
    const response = await apiHandle.get(user?.role === "Admin" ? adminRoute : vendorRoute);
    if(response && response.data){
      setVendorDetails(response.data?.vendor || null)
    }
  }



  useEffect(() => {
    dispatch(getStoreByIdAsync(id));
  }, [dispatch, id]);

  useEffect(() =>{
    if(get_store_by_id_status === asyncStatus.SUCCEEDED){
      fetchVendorDetail()
    }
  },[get_store_by_id_status ,location.state])

  const handleUpdateStatus = (newStatus) => {
    const statusObj = {
      storeId: id,
      status: newStatus,
    };

    dispatch(updateStoreStatusAsync(statusObj));
  };


  if (storeLoader) {
    return (
      <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
        <div className="flex items-center justify-center h-[40vh]">
          <Spin size="large" className="flex justify-center" />
        </div>
      </div>
    );
  }

  console.log(vendorDetails ,"vendorDetails")
  console.log(get_store_by_id_data ," get_store_by_id_data")
  return (
    <div className="flex justify-center">
      <Card className="max-w-4xl mx-auto w-full shadow-lg rounded-xl overflow-hidden p-2">
        <Row gutter={24}>
          <Col xs={24} md={24} className="p-2">
            {/* Using the StorePreview component with editable=true */}
            <StorePreview 
              storeData={get_store_by_id_data?.store || {}}
              status={get_store_by_id_data?.store?.status}
              vendorDetails={vendorDetails}
              onUpdateStatus={handleUpdateStatus}
              isLoading={updateStoreStatusLoader}
              editable={true}
            />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default StoreDetail;